function getMatchDetails(state, matchid) {

    const match = state.matches.filter((m) => m._id === matchid)[0] !== undefined ? state.matches.filter((m) => m._id === matchid)[0] : {}
    const homeTeam = state.teams.filter((t) => t._id === match.homeTeam)[0] !== undefined ? state.teams.filter((t) => t._id === match.homeTeam)[0] : {}
    const awayTeam = state.teams.filter((t) => t._id === match.awayTeam)[0] !== undefined ? state.teams.filter((t) => t._id === match.awayTeam)[0] : {}
    const stadium = state.stadiums.filter((s) => s._id === match.stadium)[0] !== undefined ? state.stadiums.filter((s) => s._id === match.stadium)[0] : {}

    return {
        match: match,
        homeTeam: homeTeam,
        awayTeam: awayTeam,
        stadium: stadium
    }
}

export default getMatchDetails